import { render } from "./SurveyQ1.vue?vue&type=template&id=ca85d6fc&ts=true"
import script from "./SurveyQ1.vue?vue&type=script&lang=ts"
export * from "./SurveyQ1.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__